import { Flow, FlowCreate, Paginated } from "@/types";
import { del, get, post, put } from "./client";

export interface ListFlowsParams {
  limit?: number;
  offset?: number;
  includeStatus?: boolean;
}

export async function listFlows(params: ListFlowsParams = {}): Promise<Paginated<Flow>> {
  const query = new URLSearchParams();
  if (params.limit !== undefined) {
    query.set("limit", String(params.limit));
  }
  if (params.offset !== undefined) {
    query.set("offset", String(params.offset));
  }
  if (params.includeStatus) {
    query.set("include_status", "true");
  }
  const qs = query.toString();
  return get<Paginated<Flow>>(`/flows${qs ? `?${qs}` : ""}`);
}

export async function getFlow(id: string): Promise<Flow> {
  return get<Flow>(`/flows/${id}`);
}

export async function createFlow(flow: FlowCreate): Promise<Flow> {
  return post<Flow>("/flows", flow);
}

export async function updateFlow(id: string, flow: FlowCreate): Promise<Flow> {
  return put<Flow>(`/flows/${id}`, flow);
}

export async function deleteFlow(id: string): Promise<void> {
  return del(`/flows/${id}`);
}

export async function toggleFlow(id: string): Promise<Flow> {
  return post<Flow>(`/flows/${id}/toggle`, {});
}
